const state = {
designerStore:
  [
    {
        id: 1,
        title_en: "UX/UI Design Starter",
        title_ua: "UX/UI Дизайн Стартовий",
        title_es: "Diseño UX/UI Inicio",
        regnumber: "TP08523730",
        grade: "938 / 1000",
        examdate: "18.05.2021",
        image: "https://testprovider.com/ru/search-certificate/tp08523730",
    },
    {
        id: 2,
        title_en: "UX/UI Design Essential",
        title_ua: "UX/UI Дизайн Базовий",
        title_es: "Diseño UX/UI Básico",
        regnumber: "TP37142600",
        grade: "1000 / 1000",
        examdate: "20.05.2021",
        image: "https://testprovider.com/ru/search-certificate/tp37142600",
    },
    {
        id: 3,
        title_en: "UX/UI Mobile App Design",
        title_ua: "UX/UI Дизайн мобільних додатків",
        title_es: "Diseño UX/UI de Apps Móviles",
        regnumber: "TP57418431",
        grade: "1000 / 1000",
        examdate: "23.05.2021",
        image: "https://testprovider.com/ru/search-certificate/tp57418431",
    },
    {
        id: 4,
        title_en: "Figma. Online store design",
        title_ua: "Figma. Дизайн інтернет-магазину",
        title_es: "Figma. Diseño de tienda en línea",
        regnumber: "TP46637985",
        grade: "1000 / 1000",
        examdate: "25.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp46637985",
    },
  ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
    state,
    getters,
    mutations,
    actions
};